module.exports = __webpack_public_path__ + "static/media/MentionsLegalesCreditdaba_Ar.6bbed797.pdf";